import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import HelpAgent from 'containers/Help/HelpAgent/HelpAgent';
import { closeHelpAgent, selectHelpAgentOpen } from 'store/layoutSlice';
/**
 * Mounted once in Layout so the AI agent can be opened from any page (the
 * stars button in dashboard headers, the help center link) and keeps its
 * conversation while the user navigates.
 */
function HelpAgentManager() {
    var _a;
    const dispatch = useDispatch();
    const { i18n } = useTranslation();
    const open = useSelector(selectHelpAgentOpen);
    const language = ((_a = i18n.language) === null || _a === void 0 ? void 0 : _a.toLowerCase().startsWith('en')) ? 'en' : 'pl';
    return (React.createElement(HelpAgent, { key: language, language: language, open: open, onClose: () => dispatch(closeHelpAgent()) }));
}
export default HelpAgentManager;
